export const noCertPaths = [
  "Login",
  "ForgotPassword",
  "Profile",
  "UserOperations",
  "Account",
  "CallTemplateCreate",
  "CallTemplateView",
  "Dashboard",
];
export const loginPaths = [
  "Login",
  "Logout",
  "ForgotPassword",
  "CreatePassword",
  "CdnUploader",
];
export const hideNavbarPaths = [
  "Login",
  "Logout",
  "ForgotPassword",
  "CreatePassword",
];
